<template>
  <div class="page">
    <PageTitle :title="title" :routes="routes" :border="false"></PageTitle>
    <router-view></router-view>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import PageTitle from '@/components/PageTitle'
export default {
  name: 'FeedReport',
  components: {
    PageTitle
  },
  computed: {
    title() {
      let name = '投诉管理'
      if (this.routes.length > 0) name = this.routes[this.routes.length - 1].name
      return name
    },
    ...mapState({
      routes: 'route'
    })
  },
  mounted() {
  },
  beforeDestroy() {
    this.$store.commit('changeRoute', null)
  },
  beforeRouteUpdate (to, from, next) {
    let path = to.path
    if (path.indexOf('/') === 0) path = path.substring(1)
    const name = to.query.id ? 'FeedReport' : to.name
    const chineseName = {
      FeedReportDetail: '被举报动态预览',
    }
    const toPage = {
      link: path,
      name: chineseName[name]
    }
    this.$store.commit('changeRoute', toPage)
    next()
  }
}
</script>

<style scoped lang="scss">
.page {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
